<template>
  <input v-if="type == 'tel'" type="tel" class="ipt_item"
    :value="value"
    pattern="[0-9]*"
    v-on="inputListeners"
    :placeholder="placeholder"
    :maxlength="maxLenght"
    @focus="handleFocus"/>
  <input v-else :type="type" class="ipt_item"
    :value="value"
    v-on="inputListeners"
    :placeholder="placeholder"
    :maxlength="maxLenght"
    @focus="handleFocus"/>
</template>

<script>
export default {
  name: 'IInput',
  props: {
    value: String,
    placeholder: {
      type: String,
      default: 'placeholder'
    },
    type: {
      type: String,
      default: 'text'
    },
    maxLenght: {
      type: Number,
      default: 1000
    }
  },
  methods: {
    handleFocus() {
      this.$emit('handleFocus');
    }
  },
  computed: {
    inputListeners() {
      const vm = this;
      return Object.assign({},
        this.$listeners,
        {
          input(evt) {
            vm.$emit('input', evt.target.value);
          }
        }
      );
    }
  }
};
</script>

<style scoped lang="stylus">
$grayCorlor = #C2C2CC
.ipt_wrap_out {
  display flex
  flex-direction clumn
}
.ipt_item {
  height 64px
  width 100%
  background-color transparent
  border none
  color #41414D
  font-weight 500
}
::placeholder {
  color $grayCorlor
  font-weight 400
  font-size 14px
  line-height 20px
}
</style>
